import { Typography } from '@mui/material'
import { Stack } from '@mui/material'
import { tokens } from "@/tokens";

const SelectClientBanner = () => {
  return (
    <Stack flex={1} justifyContent="center" alignItems="center">
      <Typography variant="h5" fontSize={24} fontWeight={tokens.fontWeight.heavy} color="#2E2C34">
        Please select a client to view the data
      </Typography>
    </Stack>
  );
};

export default SelectClientBanner;
